'use client'

import { Accordion } from 'fukku/Accordion'
import { useMemo, useState } from 'react'
import { useReturnMethodsInfo } from 'shipping-and-returns/hooks/useReturnMethodsInfo/useReturnMethodsInfo'
import type { UnavailableReturnMethod } from 'shipping-and-returns/types/ReturnsInfo.types'
import { cx } from 'utils/cx'

import { ReturnDaysText } from './components/ReturnDaysText/ReturnDaysText'
import { SingleReturnInfo } from './components/SingleReturnInfo/SingleReturnInfo'

import styles from './ReturnMethodsInfoContainer.module.scss'

const ACCORDION_ID = 'accordion-returns'

interface ReturnMethodsInfoContainerProps {
	readonly isPage?: boolean
	readonly onClose?: () => void
	readonly onClickAccordion?: (accordionId: string) => void
	readonly onLoad?: () => void
	readonly orderType?: string
	readonly orderId?: string
	readonly purchaseId?: string
	readonly unavailableReturnMethods?: UnavailableReturnMethod[]
	readonly barcode?: string | null
	readonly onLocateStoreClick?: () => void
}
export function ReturnMethodsInfoContainer({
	isPage,
	onClose = () => {},
	onClickAccordion = () => {},
	orderType,
	orderId,
	purchaseId,
	barcode,
	unavailableReturnMethods,
	onLocateStoreClick,
}: ReturnMethodsInfoContainerProps) {
	const { methodsInfo, maximumReturnDays } = useReturnMethodsInfo({
		orderType,
		orderId,
		purchaseId,
		onClickAccordion,
		barcode,
		unavailableReturnMethods,
		onLocateStoreClick,
		onCloseEvent: onClose,
		isMyPurchasesPage: !isPage,
	})

	const [expandedId, setExpandedId] = useState<string | null>(null)

	const accordionsData = useMemo(
		() => ({
			id: ACCORDION_ID,
			data: methodsInfo.map((method) => ({
				...method,
				showExpanded: expandedId === method.id,
				onExpandedStart: (_id: string) => {
					setExpandedId(method.id)
				},
			})),
		}),
		[methodsInfo, setExpandedId, expandedId]
	)

	return (
		<>
			{isPage && (
				<ReturnDaysText
					maximumReturnDays={maximumReturnDays}
					orderType={orderType}
				/>
			)}
			{methodsInfo.length === 1 ? (
				<SingleReturnInfo
					className={cx(isPage && styles.pageWrap)}
					methodInfo={methodsInfo[0]}
				/>
			) : (
				<div className={cx(styles.accordions, isPage && styles.pageWrap)}>
					<Accordion {...accordionsData} />
				</div>
			)}
		</>
	)
}
